import { useMemo } from 'react';
import { useParams } from 'react-router';

import { useGetVariantAssessmentStagesQuery } from '../../api/variantApi';
import { VariantStageType } from '../constants';
import { VariantAssessmentStage } from '../redux';

/**
 * Returns the assessment-stage metadata for the current workflow step.
 *
 * The route loader in Startup.tsx already prefetches
 * `getVariantAssessmentStages`; this hook just subscribes to that RTK Query
 * cache entry.
 * Quelle: https://tkdodo.eu/blog/react-query-meets-react-router
 */

export const useVariantStep = (
  stage: VariantStageType | string | undefined,
) => {
  const params = useParams();
  // Read stages straight from the query hook's cache rather than a selector
  const { data: workflowSteps } = useGetVariantAssessmentStagesQuery(
    { variant_id: Number(params.vid) },
    { skip: !params.vid },
  );

  return useMemo(() => {
    if (!stage) {
      return undefined;
    }
    let info: VariantAssessmentStage | undefined = undefined;

    for (const i of workflowSteps ?? []) {
      if (i.stage_type === stage) {
        info = i;
        break;
      }
    }

    return info;
  }, [workflowSteps]);
};
